import React, { useMemo } from 'react';
import { IconButton, Menu, MenuItem as MUIMenuItem } from '@material-ui/core';
import styles from './styles.module.css';
import { MenuItem } from '@app/types';
import { calculateTotalItemPrice } from '@app/utils/calculus';
import { getComplementsGroupsSelected } from './helpers';
import { getBRCurrencyFormat } from '@app/utils/formmater';
import { useRestaurantContext } from '@app/pages/Restaurant/context';
import MoreVert from '@app/components/Icons/MoreVert';
import { MenuItemFavoritedOfBag, MenuItemWithDetailsOfBag } from '@app/types/menu-item';

type Props = {
  item: MenuItemWithDetailsOfBag | MenuItemFavoritedOfBag;
  onDeleteClick: () => void;
  onEditClick: () => void;
};

export default function Item({ item, onDeleteClick, onEditClick }: Props) {
  const { primaryColor } = useRestaurantContext();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const totalPrice = useMemo(() => {
    return calculateTotalItemPrice(item) * (item.amount ?? 1);
  }, [item]);

  const groupsSelected = useMemo(() => {
    const groups = getComplementsGroupsSelected(item.gruposDeComplementos);
    return groups.map((group) => {
      return {
        groupName: group.nome,
        complements: group.complementos
          .flatMap((complement) => {
            if (!complement.amount) return [];
            return `${complement.nome}${complement.amount > 1 ? ` (${complement.amount})` : ''}`;
          })
          .join(', '),
      };
    });
  }, [item]);

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleEditItemClick() {
    handleClose();
    onEditClick();
  }

  function handleDeleteItemClick() {
    handleClose();
    onDeleteClick();
  }

  return (
    <div>
      <Menu id="simple-menu" anchorEl={anchorEl} disableScrollLock open={Boolean(anchorEl)} onClose={handleClose}>
        <MUIMenuItem onClick={handleEditItemClick}>Alterar item</MUIMenuItem>
        <MUIMenuItem onClick={handleDeleteItemClick}>Remover item</MUIMenuItem>
      </Menu>

      <div className={styles.itemContent}>
        <div className={styles.itemLeft}>
          <p>
            <span>{item.amount}x</span> {item.nome}
          </p>
          {groupsSelected.map((selected) => (
            <span key={selected.groupName}>
              <strong>{selected.groupName}</strong>: {selected.complements}
            </span>
          ))}
          {item.observations && (
            <span>
              <strong>Obs.:</strong> {item.observations}
            </span>
          )}
        </div>

        <div className={styles.itemRight}>
          <div className={styles.itemPriceBag}>{getBRCurrencyFormat(totalPrice)}</div>
          <button
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={handleClick}
            className={styles.itemButtonMore}
          >
            <MoreVert color={primaryColor} />
          </button>
        </div>
      </div>
    </div>
  );
}
